<template>
  <v-dialog v-model="dialog" width="600" persistent v-if="dialog">
    <v-card>
      <v-toolbar max-height="64" class="mb-2">
        <v-toolbar-title>
          {{ $t("withdraw") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-2 mb-4 px-6">
        <p class="mb-0 mt-3 overline">Usuário</p>
        <div class="pa-2 px-6 d-flex flex-column">
          <span>Nome: {{ withdrawData.nome }}</span>
        </div>
        <p class="mb-0 mt-3 overline">Saque</p>
        <div class="pa-2 px-6 d-flex flex-column">
          <span>
            Data:
            {{
              new Date(
                withdrawData.data_cadastro.replace(" ", "T")
              ).toLocaleString()
            }}
          </span>
          <span>Valor: {{ withdrawData.valor_solicitado }}</span>
        </div>

        <p class="mb-0 mt-3 overline">PIX</p>
        <div class="pa-2 px-6 d-flex flex-column">
          <span>Chave Pix: {{ withdrawData.chave_pix }} </span>
          <span>Tipo Chave: {{ withdrawData.tipo_chave }}</span>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          color="primary"
          type="submit"
          @click="withdrawForPlayer"
          :loading="withdrawLoading"
          :disabled="withdrawLoading"
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "withdrawData"],
  data: () => ({
    withdrawLoading: false,
  }),
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    withdrawForPlayer() {
      this.withdrawLoading = true;

      const body = {
        withdraw_id: this.withdrawData.id,
      };

      this.$axios
        .post(
          "/colab/bankOnline/authorizeDetachedCashout",
          this.$formdata(body)
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.$emit("closeDialog");
          this.$emit("resetWithdrawId");
        })
        .catch(() => {})
        .finally(() => {
          this.withdrawLoading = false;
        });
    },
  },
};
</script>
